import { atom } from 'recoil';

const submissionAtom = atom({
	key: 'submissionAtom',
	default: {}
});

export const formSchemaAtom = atom({
	key: 'formSchemaAtom',
	default: {}
});

export const formDefaultAtom = atom({
	key: 'formDefaultAtom',
	default: {}
});

export const submissionGuidAtom = atom({
	key: 'submissionGuidAtom',
	default: ''
});

export const correlationGuidAtom = atom({
	key: 'correlationGuidAtom',
	default: ''
});

export const shortCodeAtom = atom({
	key: 'shortCodeAtom',
	default: ''
});

export default submissionAtom;
